export default "__VITE_ASSET__Hm6FesE6__"